import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parseNavHref, scrollToElementById, scrollToTop } from '../utils/scroll';

/**
 * Returns a click handler for in-app navigation with smooth scrolling.
 */
export function useNavClick(onAfterNavigate) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (e, href) => {
      e.preventDefault();
      const { pathname, hash } = parseNavHref(href);
      const samePath = location.pathname === pathname;

      if (samePath && !hash) {
        scrollToTop();
        onAfterNavigate?.();
        return;
      }

      if (samePath && hash) {
        if (location.hash !== `#${hash}`) {
          navigate({ pathname, hash: `#${hash}` }, { replace: false });
        } else {
          scrollToElementById(hash);
        }
        onAfterNavigate?.();
        return;
      }

      navigate(hash ? `${pathname}#${hash}` : pathname);
      onAfterNavigate?.();
    },
    [location.pathname, location.hash, navigate, onAfterNavigate]
  );
}
